<div class="flipbook-wrapper">
    <div class="flipbook-header" *ngIf="name">
        <h3>{{name}}</h3>
    </div>
    <iframe *ngIf="pdfUrl" [src]="flipbookSrc | safeUrl" class="flipbook-iframe" frameborder="0" allowfullscreen allowtransparency="true"></iframe>
</div>
